'use client';

import DrugSearch from './DrugSearch';
import SavedDrugList from './SavedDrugList';
import { ComponentFields } from 'types/content';
import { useAppSelector } from 'lib/hooks';
import { selectCurrentPrescriptions } from 'slices/prescriptionSlice';
import CheckCircleIcon from 'components/icons/CheckCircleIcon';
import { useEffect, useRef } from 'react';
import { ANALYTICS_EVENTS, capture, secondsSince } from 'lib/analytics';

const DrugForm = ({ data, onContinue }: ComponentFields) => {
  const savedDrugs = useAppSelector(selectCurrentPrescriptions);
  const mountTimeRef = useRef<number | null>(null);
  useEffect(() => {
    mountTimeRef.current = Date.now();
    capture(ANALYTICS_EVENTS.rxFormViewed);
  }, []);

  const title = data.elements.title.value;
  const subtitle = data.elements.subtitle.value;
  const continueEmpty = data.elements.continueTextEmpty.value;
  const continuePopulated = data.elements.continueTextPopulated.value;

  const handleContinue = () => {
    capture(ANALYTICS_EVENTS.rxFormCompleted, {
      duration_seconds: secondsSince(mountTimeRef.current),
    });
    onContinue();
  };

  return (
    <section className="form-container">
      <DrugSearch title={title} subtitle={subtitle} />
      <SavedDrugList drugs={savedDrugs} />
      <button
        className={`button ${
          savedDrugs.length === 0 ? 'secondary' : 'primary checked'
        }`}
        onClick={handleContinue}
      >
        {savedDrugs.length === 0 ? continueEmpty : continuePopulated}
        {savedDrugs.length > 0 && <CheckCircleIcon color="white" />}
      </button>
    </section>
  );
};

export default DrugForm;
